/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button, Table, TableColumnsType} from "antd";
import {CheckOutlined, DeleteOutlined, EditOutlined} from "@ant-design/icons";
import {formatCurrency, getBaechaMHTypeStr, getBaechaPriceTypeStr} from "../../../util/format";
import {BaechaWorkDay} from "../../../types/BaechaWorkDay";
import {Baecha} from "../../../types/Baecha";
import {formatKorDate} from "../../../util/date";

interface BaechaWorkDayTableProps {
	baechaData: Baecha | undefined;
	baechaWorkDayData: BaechaWorkDay[];
	onClickBaechaWorkDay: (baechaWorkDay: BaechaWorkDay, action: 'edit' | 'delete' | 'done') => void;
}

const BaechaWorkDayTable = ({ baechaData, baechaWorkDayData, onClickBaechaWorkDay }: BaechaWorkDayTableProps) => {
	// 수정: 1. 월대면 수정 안 됨. 2. 이미 완료돼있으면 안 됨.
	const getIsShowEditBtn = (baechaWorkDay: BaechaWorkDay) => {
		if (baechaData?.status === "balju_cancel") return false;
		if (baechaData?.isWorkMonth) return false;
		return !baechaWorkDay.doneDate && !baechaWorkDay.doneMemberId;
	};

	// 삭제: 1. 첫번째 일정은 무조건 안 됨. 2. 완료 상태면 안 됨.
	const getIsShowDeleteBtn = (baechaWorkDay: BaechaWorkDay) => {
		if (baechaData?.status === "balju_cancel") return false;
		if (baechaWorkDayData[0].id === baechaWorkDay.id) return false;
		return !baechaWorkDay.doneDate && !baechaWorkDay.doneMemberId;
	}

	// 완료: 1. 이미 완료돼있으면 안 됨. 2. 앞선 일정이 완료되어 있어야 함.
	const getIsShowDoneBtn = (baechaWorkDay: BaechaWorkDay) => {
		if (baechaData?.status === "balju_cancel") return false;
		if (baechaWorkDay.doneDate || baechaWorkDay.doneMemberId) return false;
		const index = baechaWorkDayData.findIndex((item) => item.id === baechaWorkDay.id);
		const earlier = baechaWorkDayData.slice(0, index);
		return earlier.every((item) => item.doneDate || item.doneMemberId);
	}

	if (baechaWorkDayData.length === 0) return null;
	return (
		<Table
			bordered
			size='small'
			style={{ tableLayout: 'fixed', width: '100%' }}
			pagination={false}
			dataSource={baechaWorkDayData.map((row) => ({...row, key: row.id}))}
			columns={[
				{
					title: '작업 날짜',
					dataIndex: 'workDate',
					key: 'workDate',
					width: 100,
					align: 'center',
					render: (value: any, record: BaechaWorkDay, index: number) => formatKorDate(value),
				},
				{
					title: '작업 시간',
					dataIndex: 'mhType',
					key: 'mhType',
					width: 70,
					align: 'center',
					render: (text: string) => getBaechaMHTypeStr(text),
				},
				{
					title: '단가 유형',
					dataIndex: 'priceType',
					key: 'priceType',
					width: 70,
					align: 'center',
					render: (text: string) => getBaechaPriceTypeStr(text),
				},
				{
					title: '단가',
					dataIndex: 'price',
					key: 'price',
					width: 100,
					align: 'center',
					render: (text: string) => formatCurrency(Number(text), 'KRW'),
				},
				{
					title: '야간 연장',
					dataIndex: 'overtimePrice',
					key: 'overtimePrice',
					width: 100,
					align: 'center',
					render: (text: string) => formatCurrency(Number(text), 'KRW'),
				},
				{
					title: '수정',
					dataIndex: 'edit',
					key: 'edit',
					width: 50,
					align: 'center',
					render: (value: any, record: BaechaWorkDay, index: number) => {
						const isShowEditBtn = getIsShowEditBtn(record);
						if (!isShowEditBtn) return null;
						return (
							<Button
								shape='circle'
								type='default'
								onClick={() => onClickBaechaWorkDay(record, 'edit')}
							>
								<EditOutlined/>
							</Button>
						)
					},
				},
				{
					title: '삭제',
					dataIndex: 'delete',
					key: 'delete',
					width: 50,
					align: 'center',
					render: (value: any, record: BaechaWorkDay, index: number) => {
						const isShowDelete = getIsShowDeleteBtn(record);
						if (!isShowDelete) return null;
						return (
							<Button
								danger
								shape='circle'
								type='primary'
								onClick={() => onClickBaechaWorkDay(record, 'delete')}
							>
								<DeleteOutlined/>
							</Button>
						);
					},
				},
				{
					title: '완료',
					dataIndex: 'done',
					key: 'done',
					width: 50,
					align: 'center',
					render: (value: any, record: BaechaWorkDay, index: number) => {
						const isShowDoneBtn = getIsShowDoneBtn(record);
						if (record.doneDate || record.doneMemberId) return '완료됨';
						if (!isShowDoneBtn) return null;
						return (
							<Button
								shape='circle'
								type='primary'
								onClick={() => onClickBaechaWorkDay(record, 'done')}
							>
								<CheckOutlined />
							</Button>
						);
					},
				},
			] as TableColumnsType<BaechaWorkDay>}
		/>
	);
}

export default BaechaWorkDayTable;
